import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import ContactBalances, { initialLedgerDataProps } from "./ContactBalances"
import ContactInvoicesContextProvider, {
  contactProps,
  initialInvoicesProps,
  marinaProps,
} from "./ContactInvoicesContextProvider"
import ContactInvoicesPrintView from "./ContactInvoicesPrintView"
import ContactInvoicesTable from "./ContactInvoicesTable"

const ContactInvoicesPanel = ({
  contactId,
  initialLedgerData,
  initialInvoiceData,
  printViewEnabled = false,
  contact,
  marina,
}) => {
  return (
    <ContactInvoicesContextProvider
      contactId={contactId}
      initialInvoices={initialInvoiceData}
      printViewEnabled={printViewEnabled}
      contact={contact}
      marina={marina}
    >
      <div
        data-testid="contact-invoices-panel"
        className={classNames("flex flex-col space-y-4 px-4", {
          "print:hidden": printViewEnabled,
        })}
      >
        <ContactBalances initialLedgerData={initialLedgerData} />
        <ContactInvoicesTable
          contactId={contactId}
          initialInvoices={initialInvoiceData}
        />
      </div>
      {printViewEnabled ? <ContactInvoicesPrintView /> : null}
    </ContactInvoicesContextProvider>
  )
}

ContactInvoicesPanel.propTypes = {
  initialLedgerData: PropTypes.shape(initialLedgerDataProps).isRequired,
  contactId: PropTypes.string.isRequired,
  initialInvoiceData: PropTypes.arrayOf(PropTypes.shape(initialInvoicesProps))
    .isRequired,
  printViewEnabled: PropTypes.bool,
  contact: PropTypes.shape(contactProps).isRequired,
  marina: PropTypes.shape(marinaProps).isRequired,
}

export default ContactInvoicesPanel
